<!--强烈程度对话框，适用于用户必须做出交互的情况，否则即执行默认行为-->
<template>
    <isc-dialog
        class="dialog-highly"
        append-to-body
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="visible"
        width="420px"
    >
        <div class="highly d-flex flex-column align-center">
            <div class="highly__icon" :class="[`highly__icon--${type}`]"></div>
            <h2 class="highly__title mb4">{{ title }}</h2>
            <h2 v-if="subTitle" class="highly__sub-title mb4">{{ subTitle }}</h2>
            <p v-if="desc" class="highly__desc">{{ descLabel }}</p>
            <div
                v-if="sureMethod && sureLabel"
                class="highly__actions d-flex justify-space-between mb8"
                :class="{ 'highly__actions--cancelable': cancelLabel }"
            >
                <button-xlarge :width="buttonWidth" type="primary" :loading="loading" @click="onSure">
                    {{ sureLabel }}
                </button-xlarge>
                <button-xlarge v-if="cancelLabel" :width="buttonWidth" plain @click="onCancel">
                    {{ cancelLabel }}
                </button-xlarge>
            </div>
            <p v-if="tips" class="highly__tips">{{ tipsLabel }}</p>
        </div>
    </isc-dialog>
</template>

<script>
import { stringAssign } from '@isyscore/utils/string';
import { error } from '../../utils/message';
import ButtonXlarge from '../button/button-xlarge';
export default {
    name: 'DialogHighly',
    components: { ButtonXlarge },
    props: {
        // 可选：warning、success、danger、info
        type: {
            type: String,
            default: 'warning'
        },

        title: {
            type: String,
            default: '标题'
        },

        subTitle: {
            type: String,
            default: ''
        },

        // 使用 ${countDown} 来代替倒计时秒数，例如：${countDown} 秒后关闭
        // ${countDown} 只有设置了 countDown 才有效
        desc: {
            type: String,
            default: ''
        },

        countDown: {
            type: [Number, String],
            default: 0
        },

        sureLabel: {
            type: String,
            default: ''
        },

        cancelLabel: {
            type: String,
            default: ''
        },

        // 使用 ${countDown} 来代替倒计时秒数，例如：${countDown} 秒后关闭
        // ${countDown} 只有设置了 countDown 才有效
        tips: {
            type: String,
            default: ''
        },

        sureMethod: {
            type: Function,
            default: async () => {}
        },

        cancelMethod: {
            type: Function,
            default: async () => {}
        }
    },

    data() {
        return {
            visible: false,
            loading: false,
            countDownRemain: 0
        };
    },

    computed: {
        buttonWidth() {
            return this.cancelLabel ? '140px' : '200px';
        },

        countDownNumber() {
            return parseInt(this.countDown || 0);
        },

        descLabel() {
            const { countDownNumber, countDownRemain, desc } = this;

            if (!countDownNumber) return desc;

            return stringAssign(desc, { countDown: countDownRemain });
        },

        tipsLabel() {
            const { countDownNumber, countDownRemain, tips } = this;

            if (!countDownNumber) return tips;

            return stringAssign(tips, { countDown: countDownRemain });
        }
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },

    methods: {
        open() {
            this.visible = true;
            this.startCountDown();
        },

        close() {
            this.visible = false;
        },

        startCountDown() {
            const { countDownNumber } = this;

            if (!countDownNumber) return;

            this.countDownRemain = countDownNumber;
            this.timer = setInterval(() => {
                this.countDownRemain--;

                if (this.countDownRemain === 0) {
                    clearInterval(this.timer);
                    this.onSure();
                }
            }, 1000);
        },

        async onSure() {
            try {
                this.loading = true;
                await this.sureMethod();
            } catch (err) {
                error(err);
            } finally {
                this.loading = false;
            }
        },

        onCancel() {
            const { cancelMethod } = this;

            if (cancelMethod) {
                cancelMethod();
            } else {
                this.visible = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.highly {
    padding-top: 4px;
    padding-bottom: 4px;

    &__icon {
        width: 120px;
        height: 120px;
        background-size: cover;
        margin-bottom: 32px;

        &--danger {
            background-image: url(./assets/danger.png);
        }

        &--info {
            background-image: url(./assets/info.png);
        }

        &--success {
            background-image: url(./assets/success.png);
        }

        &--warning {
            background-image: url(./assets/warning.png);
        }
    }

    &__title,
    &__sub-title {
        font-size: 20px;
        font-weight: 500;
        color: #323232;
        line-height: 28px;
    }

    &__desc,
    &__tips {
        font-size: 12px;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 16px;
    }

    &__actions {
        margin-top: 40px;
        width: 200px;

        ::v-deep {
            .isc-button {
                line-height: normal;
                font-size: 16px;
                font-weight: 400;
            }
        }

        &--cancelable {
            width: 300px;
        }
    }
}
</style>
